import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { INTL_PREFIX } from '@/messages/const';

export const intlPrefix = `${INTL_PREFIX.PAYMENT}.v12finance`;

export const defined = defineMessages({
  currentSelection: {
    defaultMessage: 'Current selection :',
    id: `${intlPrefix}.currentSelection`,
  },
  totalAmountPayable: {
    defaultMessage: 'Total amount payable',
    id: `${intlPrefix}.totalAmountPayable`,
  },
  selectATermDuration: {
    defaultMessage: 'Select a term duration',
    id: `${intlPrefix}.selectATermDuration`,
  },
  months: {
    defaultMessage: 'Months',
    id: `${intlPrefix}.months`,
  },
  aprRepresentative: {
    defaultMessage: 'APR Representative',
    id: `${intlPrefix}.aprRepresentative`,
  },
  adjustYourDeposit: {
    defaultMessage: 'Adjust your deposit',
    id: `${intlPrefix}.adjustYourDeposit`,
  },
  useSliderToAdjustYourDeposit: {
    defaultMessage: 'Use slider to adjust your deposit.',
    id: `${intlPrefix}.useSliderToAdjustYourDeposit`,
  },
  deposit: {
    defaultMessage: 'Deposit',
    id: `${intlPrefix}.deposit`,
  },
  totalAmountOfCredit: {
    defaultMessage: 'Total amount of credit',
    id: `${intlPrefix}.totalAmountOfCredit`,
  },
  monthlyPayment: {
    defaultMessage: 'Monthly payment',
    id: `${intlPrefix}.monthlyPayment`,
  },
  loanTerm: {
    defaultMessage: 'Loan term',
    id: `${intlPrefix}.loanTerm`,
  },
  representativeAPR: {
    defaultMessage: 'Representative APR',
    id: `${intlPrefix}.representativeAPR`,
  },
  fixedAnnualRateOfInterest: {
    defaultMessage: 'Fixed Annual Rate of interest',
    id: `${intlPrefix}.fixedAnnualRateOfInterest`,
  },
  totalPrice: {
    defaultMessage: 'Total Price',
    id: `${intlPrefix}.totalPrice`,
  },
  payWithV12Finance: {
    defaultMessage: ' Confirm and pay with V12 Finance',
    id: `${intlPrefix}.payWithV12Finance`,
  },
  sameAddressCheckbox: {
    defaultMessage:
      'I agree that the address on the finance agreement can be used as the shipping address to proceed with the order.',
    id: `${intlPrefix}.sameAddressCheckbox`,
  },
  installmentInfoPrefix: {
    defaultMessage:
      'Payment in instalments with 0% interest from {amount} /month',
    id: `${intlPrefix}.installmentPrefix`,
  },
  installmentInfoWith: {
    defaultMessage: 'with',
    id: `${intlPrefix}.installmentInfoWith`,
  },
  installmentInfoViewOptions: {
    defaultMessage: 'View options.',
    id: `${intlPrefix}.installmentInfoViewOptions`,
  },
});

export const Description = (loanAmount: JSX.Element) => (
  <FormattedMessage
    defaultMessage='Our finance options can help you spread the cost of your purchase over set months.{br} ​Minimum loan amount {loanAmount}'
    id={`${intlPrefix}.description`}
    values={{
      br: <br />,
      loanAmount,
    }}
  />
);

export const Disclaimer = () => (
  <FormattedMessage
    defaultMessage={`Breitling UK Limited is authorised and regulated by the Financial
            Conduct Authority and is the broker and not the lender. Our FCA
            registration number is 723426. Breitling UK Limited offers credit
            products from Secure Trust Bank PLC trading as V12 Retail Finance.
            Credit is provided subject to affordability, age and status. Minimum
            spend applies. Not all products offered by Secure Trust Bank PLC are
            regulated by the Financial Conduct Authority. Terms and conditions
            apply. For more information visit {v12Link}.
            Breitling does not receive commissions for interest free credit
            provided. Please spend responsibly. Late or missing payments can
            have serious consequences for you.`}
    id={`${intlPrefix}.disclaimer`}
    values={{
      v12Link: (
        <LinkWithLocale
          href='https://www.v12retailfinance.com/'
          target='_blank'
        >
          https://www.v12retailfinance.com/
        </LinkWithLocale>
      ),
    }}
  />
);

export const ErrorV12AmountLimit = ({
  maxAmount,
  minAmount,
}: {
  maxAmount: string;
  minAmount: string;
}) => (
  <FormattedMessage
    defaultMessage='You can pay with V12Finance for orders between {minAmount} and {maxAmount}'
    id={`${intlPrefix}.errorV12AmountLimit`}
    values={{
      minAmount,
      maxAmount,
    }}
  />
);
